import { useState } from 'react';
import { Users, Building2 } from 'lucide-react';
import ContactsPanel from './ContactsPanel';
import CompaniesPanel from './CompaniesPanel';

export default function ContactsArea({
  contacts,
  companies,
  tags,
  onSaveContact,
  onBulkUpdateContacts,
  onSaveCompany,
  onArchiveCompany,
  onFetchContacts,
  onFetchCompanies,
  contactsTotal,
  companiesTotal,
  subTab: subTabProp,
  onSubTabChange,
}) {
  const [subTabState, setSubTabState] = useState('contacts'); // 'contacts' | 'companies'
  const subTab = subTabProp || subTabState;
  const setSubTab = (value) => {
    if (onSubTabChange) onSubTabChange(value);
    else setSubTabState(value);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="shrink-0 border-b border-appSurfaceBorder bg-appSurface px-8 pt-6 pb-0">
        <div className="flex gap-1 p-1 rounded-xl bg-appPage/50 w-fit">
          <button
            type="button"
            onClick={() => setSubTab('contacts')}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-lg font-bold text-sm transition-colors ${
              subTab === 'contacts'
                ? 'bg-appPrimary text-white shadow-sm'
                : 'text-appTextMuted hover:bg-appSurfaceBorder/30 hover:text-appText'
            }`}
          >
            <Users size={18} />
            Contatos
          </button>
          <button
            type="button"
            onClick={() => setSubTab('companies')}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-lg font-bold text-sm transition-colors ${
              subTab === 'companies'
                ? 'bg-appPrimary text-white shadow-sm'
                : 'text-appTextMuted hover:bg-appSurfaceBorder/30 hover:text-appText'
            }`}
          >
            <Building2 size={18} />
            Empresas
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col min-h-0">
        {subTab === 'contacts' ? (
          <ContactsPanel
            contacts={contacts}
            companies={companies}
            tags={tags}
            onSaveContact={onSaveContact}
            onBulkUpdateContacts={onBulkUpdateContacts}
            onSaveCompany={onSaveCompany}
            onFetchContacts={onFetchContacts}
            total={contactsTotal}
          />
        ) : (
          <CompaniesPanel
            companies={companies}
            onSaveCompany={onSaveCompany}
            onArchiveCompany={onArchiveCompany}
            onFetchCompanies={onFetchCompanies}
            total={companiesTotal}
          />
        )}
      </div>
    </div>
  );
}
